// client/src/components/routing/PrivateRoute.js
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../../context/auth/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user, loadUser } = useContext(AuthContext);
  const [authChecked, setAuthChecked] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const verifyAuth = async () => {
      if (!isAuthenticated && !loading) {
        await loadUser();
      }
      setAuthChecked(true);
    };
    
    verifyAuth();
  }, [isAuthenticated, loading, loadUser]);
  
  if (loading || !authChecked) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-navy-900">
        <div className="text-center">
          <div className="relative">
            <div className="h-24 w-24 rounded-full border-t-4 border-b-4 border-blue-600 animate-spin"></div>
            <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-4 border-blue-200 animate-pulse"></div>
          </div>
          <p className="mt-4 text-xl font-medium text-blue-600 dark:text-blue-400">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  // Return children instead of Outlet
  return children;
};

export default PrivateRoute;